module.exports = __webpack_public_path__ + "static/agbo-e9b888649db03bdffb88cbe2a74f9645.png";